import { FormBase } from 'core/components';

export default class BillingForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'fromDate',
					label: 'BILLING.FROMDATE',
					rules: 'required',
				},
				{
					name: 'toDate',
					label: 'BILLING.TODATE',
					rules: 'required',
				},
			],
		};
	}
}
